import { useEffect, useRef } from 'react'
import { FiArrowRight, FiPlayCircle } from 'react-icons/fi'
import './Hero.css'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import fristImage from '../images/1.png'
const Hero = () => {
  const heroRef = useRef(null)
  const { t } = useTranslation();
  useEffect(() => {
    if (heroRef.current) {
      heroRef.current.classList.add('animate')
    }
  }, [])

  return (
     <section className="hero" ref={heroRef}>
      <div className="hero-container container">
        <div className="hero-content">
          <h1 className="hero-title">
            {t('hero.title')}
          </h1>
          <p className="hero-subtitle">
            {t('hero.subtitle')}
          </p>
          <div className="hero-cta">
            <Link to="/register" className="btn btn-primary">
              {t('hero.cta.start')} <FiArrowRight />
            </Link>
            <a href="https://youtu.be/4tRHK5d_cf0?si=4IAolXUwPiy90t-L" className="btn-text-link">
              <FiPlayCircle /> {t('hero.cta.watchDemo')}
            </a>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">98%</span>
              <span className="stat-text">{t('hero.stats.fasterPayments')}</span>
            </div>
            <div className="stat">
              <span className="stat-number">10k+</span>
              <span className="stat-text">{t('hero.stats.businessUsers')}</span>
            </div>
            <div className="stat">
              <span className="stat-number">4.9/5</span>
              <span className="stat-text">{t('hero.stats.userRating')}</span>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <img 
            src={fristImage} 
            alt={t('hero.imageAlt')} 
            className="dashboard-preview"
          />
          
          <div className="hero-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
          </div>
        </div>
        
      </div>
      <div className="hero-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path fill="#ffffff" fillOpacity="1" d="M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,224C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  )
}

export default Hero